import AppConstants from 'constants/AppConstants';

export function toggleMobileMode(): BaseTockAction {
  return {
    type: AppConstants.PERSISTED_UI_TOGGLE_MOBILE_MODE,
  };
}
